import * as React from 'react';
import { uid } from 'react-uid';
import { Field, List, ListItem } from '../../../design-system';
import { type FieldDefinition, type FormFields, type FormValues, getNestedValue } from '../../../utils/formUtils';

type Props<Values extends FormValues> = {
  fields: FormFields<Values>;
  initialValues: Values;
};

export function FormReadonly<Values extends FormValues>({ fields, initialValues }: Props<Values>): React.ReactElement {
  const fieldsWithStringKeysType = fields as Record<string, FieldDefinition<Values>>;
  const fieldsArray = Object.values<FieldDefinition<Values>>(fieldsWithStringKeysType);

  return (
    <List>
      {fieldsArray.map((field, idx) => {
        const { valueComponent: Value } = field;
        const value = getNestedValue<Values>({ key: field.id, object: initialValues });
        return (
          <ListItem key={uid(field, idx)}>
            <Field label={field.label}>{Value ? <Value value={value} /> : value}</Field>
          </ListItem>
        );
      })}
    </List>
  );
}
